/** Client → server: act on the table. Ack: `ActReply`. */
export const TABLE_ACT = 'table:act';
/** Server → client: an accepted event, projected for this connection. */
export const TABLE_EVENT = 'table:event';
/** Client → server: send a fresh projected snapshot (after a gap). Ack: `Snapshot`. */
export const TABLE_SYNC = 'table:sync';
/**
 * Client → server: the session's access token after a refresh (a bug check of issue 1306). The handshake's token is
 * fixed at connect and lives fifteen minutes; the server verifies this one as it verifies the handshake, keeps it for
 * this connection's reads of the site when it names the same person, and refuses any other. Never sent to anyone.
 * Ack: `{ ok: true }` or `{ error: 'unauthorized' }`.
 */
export const TABLE_TOKEN = 'table:token';
/**
 * Server → client: the rules the table now plays by (issue 1305), after the DM borrowed another system's or gave them
 * back: `{ campaignId, systemRules }`, the snapshot's `systemRules` read again for this person.
 */
export const TABLE_RULES = 'table:rules';
/** Server → client: whether the DM is connected and whether the table is view-only. */
export const TABLE_STATUS = 'table:status';
export function parseEnvelope(value) {
    if (typeof value !== 'object' || value === null)
        return null;
    const { n, event } = value;
    if (typeof n !== 'number' || !Number.isInteger(n) || n < 1)
        return null;
    if (typeof event !== 'object' || event === null)
        return null;
    return { n, event: event };
}
export function parseStatus(value) {
    if (typeof value !== 'object' || value === null)
        return null;
    const { dmPresent, viewOnly } = value;
    if (typeof dmPresent !== 'boolean' || typeof viewOnly !== 'boolean')
        return null;
    return { dmPresent, viewOnly };
}
//# sourceMappingURL=events.js.map